/* eslint-disable import/prefer-default-export */

import Divider from '@base/Divider/Divider';
import H4 from '@base/H4/H4';
import H6 from '@base/H6/H6';
import Image from '@base/Image';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Paper from '@base/Paper/Paper';
import SearchableDropdown from '@comp/Dropdown/SearchableDropdown';
import Button from '@base/Button/Button';
import H2 from '@base/H2/H2';

export const HeadingWrapper = styled.div`
  margin-top: ${Spacings.SPACING_3B};
`;
export const StyledDivider = styled(Divider)`
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_2B};
  ${mediaQuery.aboveTablet} {
    display: none;
  }
`;

export const OuterContainer = styled.div`
  background: rgba(45, 129, 247, 0.06);
  ${({ $isOnlineForm }) => ($isOnlineForm ? 'height: 829px;' : null)}
  ${mediaQuery.uptoMobile} {
    height: auto;
  }
`;

export const BottomContainer = styled.div`
  background-color: var(--color-base-1);
`;

export const FormContainer = styled.form`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.aboveMobile} {
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

export const CoverWrapper = styled.div`
  grid-column: 1/13;
  margin-top: ${Spacings.SPACING_10B};
  ${mediaQuery.uptoMobile} {
    grid-column: 1/25;
    grid-row: 2;
    margin-top: 0px;
    max-width: 100%;
    width: 100%;
    padding: ${Spacings.SPACING_16B} ${Spacings.SPACING_4B}
      ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
  }
`;

export const StyledP2 = styled(P2)`
  margin-right: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
`;

export const FormSubHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LeadGenCoverContent = styled.div`
  position: relative;
  max-width: 511px;
  grid-column: 1/11;
  ${mediaQuery.aboveTablet} {
    max-width: 511px;
  }
  ${mediaQuery.uptoTablet} {
    grid-column: 1/11;
  }
`;

export const AboutTitle = styled(P1)`
  margin-top: ${Spacings.SPACING_4B};
  font-size: ${Fonts.SMALL};
  font-weight: ${Fonts.LIGHT};
  line-height: 22px;
`;

export const AboutCardWrapper = styled.div`
  display: flex;
  padding-bottom: ${Spacings.SPACING_10B};
  padding-top: ${Spacings.SPACING_16B};
  flex-wrap: wrap;
  justify-content: space-between;
  ${mediaQuery.uptoMobile} {
    padding-top: ${Spacings.SPACING_9B};
  }
`;

export const SachinImageWrapper = styled.div`
  margin-bottom: -${Spacings.SPACING_3};
`;

export const DateCardWrapper = styled.div`
  width: 518px;
  margin-bottom: ${Spacings.SPACING_25B};
  ${mediaQuery.uptoTablet} {
    width: 100%;
    max-width: 100vw;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0px;
  }
`;

export const DateCardData = styled.div`
  display: flex;
  flex-direction: row;
  ${mediaQuery.uptoMobile} {
    :nth-child(3) {
      margin-top: ${Spacings.SPACING_6B};
    }
  }
`;

export const DownaladButton = styled(Button)`
  ${mediaQuery.uptoTablet} {
    margin-top: ${Spacings.SPACING_6B};
    margin-left: ${Spacings.SPACING_3B};
  }
  margin-top: ${Spacings.SPACING_8B};
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_8B};
  display: flex;
  flex-direction: column;
`;

export const TopHeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  ${mediaQuery.uptoTablet} {
    align-items: center;
  }
`;

export const DownloadWrapper = styled.a`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

export const DownloadText = styled(H6)`
  font-weight: ${Fonts.HEAVY};
`;

export const DatesWrapper = styled.div`
  display: flex;
  margin-top: ${Spacings.SPACING_4B};
  justify-content: space-between;
  ${mediaQuery.uptoTablet} {
    flex-direction: column;
    align-items: center;
  }
`;

export const DateCardbox = styled.div`
  display: flex;
  flex-direction: row;
  height: ${Spacings.SPACING_13B};
`;

export const DateMonth = styled(P2)`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.H5};
  line-height: ${Spacings.SPACING_3B};
  width: auto;
`;

export const DateValue = styled(H4)``;

export const DateText = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  margin-bottom: ${Spacings.SPACING_6};
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    font-weight: ${Fonts.REGULAR};
  }
  ${({ isLastDate }) =>
    isLastDate
      ? `color:var(--color-i-green); font-weight: ${Fonts.SEMIBOLD};`
      : ''}
`;

export const DateMonthValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ImageWrapper = styled.div`
  min-height: 196px;
  min-width: 333px;
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

export const Question = styled(H4)`
  margin-top: ${Spacings.SPACING_10B};
`;

export const Answer = styled(P1)``;

export const SubHeading = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_2B};
  align-items: center;
`;

export const DateValueWrapper = styled.div`
  min-width: ${Spacings.SPACING_30B};
  text-align: start;
`;

export const ProgressWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`;

export const AboutBlock = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${Spacings.SPACING_10B};
  min-width: 512px;
  ${mediaQuery.uptoMobile} {
    min-width: 328px;
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

export const StyledImage = styled(Image)`
  border-radius: ${Spacings.SPACING_2B} ${Spacings.SPACING_0B}
    ${Spacings.SPACING_0B} ${Spacings.SPACING_2B};
`;

export const StyledPaper = styled(Paper)`
  border: 1px solid var(--color-divider);
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  box-shadow: null;
  ${mediaQuery.aboveTablet} {
    max-width: 464px;
    padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_6B};
    grid-column: 13/23;
    margin: 0px;
  }
  ${mediaQuery.uptoTablet} {
    grid-column: 12/25;
  }
  ${mediaQuery.uptoMobile} {
    margin: 0;
  }
`;

export const LaptopImageWrapper = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

export const StyledH6 = styled(H6)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

export const DropdownValue = styled.div`
  min-width: 233px;
  margin-top: ${Spacings.SPACING_4B};
`;

export const StyledSearchableDropdown = styled(SearchableDropdown)`
  height: ${Spacings.SPACING_14B};
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_14} !important;
  ${mediaQuery.uptoMobile} {
    height: ${Spacings.SPACING_12B};
    padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_14} !important;
  }
  div {
    input {
      font-weight: ${Fonts.SEMIBOLD} !important;
      font-size: ${Fonts.P1} !important;
      padding: 0px;
      margin: 0px;
      color: var(--color-text-primary) !important;
      ::placeholder {
        color: var(--color-text-secondary);
      }
    }
    svg {
      width: ${Spacings.SPACING_4B};
    }
  }
`;

export const VerticalDivider = styled.div`
  height: ${Spacings.SPACING_10B};
  border: ${Spacings.SPACING_1} solid var(--color-i-pink-7);
  width: 0px;
  margin-right: ${Spacings.SPACING_10};
  align-self: center;
  ${({ $addMargin }) =>
    $addMargin ? `margin-left: ${Spacings.SPACING_8B}` : null}
`;

export const SachinWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 203px;
`;

export const StyledUnsatH2 = styled(H2)`
  text-align: left;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H3};
    text-align: center;
  }
`;
